import React, { Component } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/titleBar.css";

class TitleBar extends Component {
  state = {
    titleBarMenuIsOpen: false,
  };

  buildMenu = () => {
    const { menu, handleTitleBarAction } = this.props;
    if (menu && menu.menuItems.length > 0) {
      return menu.menuItems.map((i) => {
        if (i.type === "TITLEBAR_MENU_ITEM")
          return (
            <DropdownItem
              key={`titleBarMenuItemKey_${i._menuId}`}
              onClick={handleTitleBarAction(i.action)}
            >
              {i.label}
            </DropdownItem>
          );
        if (i.type === "TITLEBAR_MENU_SEPARATOR")
          return <DropdownItem key={`titleBarMenuItemKey_${i._menuId}`} divider />;
        return null;
      });
    } else return <DropdownItem disabled>No Menu Options Provided</DropdownItem>;
  };

  getToggleClass = (iconToggleValue) => {
    const { toggleValue } = this.props;
    if (toggleValue) {
      if (iconToggleValue === toggleValue) return "toolbar-toggleOn p-1";
    }
    return "";
  };

  buildToolbar = () => {
    const { menu, handleTitleBarAction, toggleValue, disabledActions } = this.props;
    if (menu && menu.toolbar && menu.toolbar.length > 0) {
      return menu.toolbar.map((i) => {
        if (i.type === "TITLEBAR_TOOLBAR_ICON") {
          return (
            <React.Fragment key={`titleBarIconFragKey_${i._iconId}`}>
              <span
                title={i.toolTipText || ""}
                className={classNames(
                  {
                    "toolbar-toggleOn p-1": toggleValue && i.toggleValue === toggleValue,
                  },
                  { "pointer-cursor": !disabledActions || !disabledActions[i.action] }
                )}
                onClick={
                  disabledActions && !disabledActions[i.action]
                    ? handleTitleBarAction(i.action)
                    : (e) => e.stopPropagation()
                }
              >
                <FontAwesomeIcon
                  id={i._iconId}
                  className={classNames(
                    "mt-1 fa-fw fa-lg",
                    { "pointer-cursor": !disabledActions || !disabledActions[i.action] },
                    {
                      "icon-white": toggleValue && i.toggleValue === toggleValue,
                    },
                    {
                      "icon-black": !toggleValue || i.toggleValue !== toggleValue,
                    },
                    { "text-muted": disabledActions && disabledActions[i.action] }
                  )}
                  icon={i.icon}
                />
                {i.label && (
                  <span
                    className={`ml-1 align-top ${
                      toggleValue && i.toggleValue === toggleValue
                        ? "text-light"
                        : "text-dark"
                    }`}
                  >
                    <small>
                      <b>{i.label}</b>
                    </small>
                  </span>
                )}
              </span>
              <span className="mr-2" />
            </React.Fragment>
          );
        }
        if (i.type === "TITLEBAR_TOOLBAR_SEPARATOR")
          return (
            <span
              key={`titleBarToolbarSeparatorKey_${i._iconId}`}
              className="mr-2 text-muted"
            >
              |
            </span>
          );
        else return "";
      });
    }
  };

  render() {
    return (
      <div className="card card-borderless my-3 mx-2">
        <div className="card-body titlebar-body py-1">
          <div className="row">
            <div className="row col-7">
              <div className="ml-2 mr-4 my-auto">
                <UncontrolledDropdown className="py-0">
                  <DropdownToggle className="py-0 px-1">
                    <FontAwesomeIcon icon="bars" />
                  </DropdownToggle>
                  <DropdownMenu>{this.buildMenu()}</DropdownMenu>
                </UncontrolledDropdown>
              </div>
              <div className="py-1">
                <span className="titlebar-titleText">{this.props.titleText}</span>
              </div>
            </div>
            <div className="col-5 ml-auto my-auto">
              <span className="float-right">{this.buildToolbar()}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TitleBar;
